import React, { useEffect, useState, useRef } from "react";
import CanvasScene from "./components/CanvasScene";
import Cursor from "./components/Cursor";
//import Modal from "./components/Modal";
import Nav from "./components/Nav";
//import AutoplayChecker from "./components/AutoplayChecker";
import NavMobile from "./components/NavMobile";
//import ScrollWindow from "./components/ScrollWindow";
//import Suspended from "./components/Suspended";
//import TestControls from "./components/TestControls";
import AudioProvider from "./components/AudioProvider";
//import WelcomeAudio from "./components/WelcomeAudio";
import Overlay from "./components/Overlay";
import BscOverlay from "./components/BscOverlay";
import CategoryBar from "./components/CategoryBar";
import { OVERLAY_RETURN_PATH_KEY, isOverlayPath } from "./components/CloseButton";
import BscBanner from "./components/BscBanner";
import useSound from 'use-sound';
//import Routes from "./Routes"

import { useRoutes, usePath, A } from "hookrouter";
import routes from "./router";

import { useMediaQuery } from 'react-responsive'
import { mediaQueries } from './config'
import audioMap from './resources/audio';





import { Link, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'


import {
  useAudioStore,
  useSceneStore,
} from './store'

import useStore from './store/scroll'

import { shadeColor } from './utils'

import "./styles.scss";


export default function App() {
  
  const { scrollRef, messages, mode,featured,  modalState, scene, pages,top, sections, scrollPos, bookState, topic, bkgdColor, character, bookIndex, loaded, defaultHeight, showBug, contentLayout } = useSceneStore(state => state)
  const { setScene,setMode,setModalState,setFeatured, setFilterGrid, setScrollPos, setBookState, setTopic, setHomeMessage, setBkgdColor, setCharacter, setTalk, setShuffled, setShowBug, setContentLayout, setBookIndex, setLoaded, setDefaultHeight, setCursorActive } = useSceneStore(state => state.actions)
  
  const wasWelcomed = useAudioStore(state => state.wasWelcomed)
  const wasWelcomedToVideo = useAudioStore(state => state.wasWelcomedToVideo)
  const wasWelcomedToFun = useAudioStore(state => state.wasWelcomedToFun)


  const [playWelcome, endWelcome] = useSound(audioMap.welcome, {
    volume: 1,
    interrupt: true,
  });

  const routeResult = useRoutes(routes);
  const suspended = useAudioStore(state => state.suspended)
 // const { playSound } = useAudioStore(state => state.actions)

  const sectionActive = useStore(state => state.sectionActive)

 
  //const location = useLocation();
  const mobile = window.innerWidth < 700;

  const isMobile = useMediaQuery({ query: mediaQueries.mobile })
  const isTablet = useMediaQuery({ query: mediaQueries.tablet })
  const isDesktop = useMediaQuery({ query: mediaQueries.desktop })

  const location = usePath();
  const path = location || window.location.pathname || '';
  const prevPathRef = useRef(location);
  const isBscFormPage = path.startsWith('/bsc/');
  const keepBscOverlayUnderForm =
    isBscFormPage && window.sessionStorage.getItem('bscFormOrigin') === 'bsc-overlay';
  const isDrawdogsPage = path.includes('/drawdogs');
  const isDrawdogsLikePage = isDrawdogsPage;


/*
  function menuClick(e, val){
      console.log('menuClick')
      setMode('grid')
      setFilterGrid(val)
      setContentLayout('grid')
      scrollToTop();
     // scrollArea.current.scrollTop = 0;
      
  }
  */

  function scrollToTop() {
    // console.log(scrollArea.current.scrollHeight)
    setMode('scroll')
    setContentLayout('spiral')
     scroll.scrollTo(0,{

       smooth: true,
       containerId: 'scroller',
      // offset: 50, // Scrolls to element + 50 pixels down the page
     
     });
   }


  function scrollToBooks() {
    console.log('scrollToBooks')
    setMode('scroll')
    setContentLayout('spiral')
    //console.log(scrollArea.current.scrollHeight*.675 +' vs '+-markerRef.current.parent.position.y)
    const decimal = (isMobile)?.65:.675;
    scroll.scrollTo(defaultHeight*decimal,{

      delay: 100,
      smooth: true,
      containerId: 'scroller',
     // offset: 50, // Scrolls to element + 50 pixels down the page
    
    });
  }

  function scrollToMore() {
    setMode('scroll')
      setContentLayout('spiral')
     

    scroll.scrollTo(defaultHeight*.9,{
       smooth: true,
       containerId: 'scroller',
      // offset: 50, // Scrolls to element + 50 pixels down the page
     
     });
   }

   function closeModal(){
    setModalState(false)
    setFeatured(null)
  }
/*
  function checkAutoplay() {
    // Create an AudioContext
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();

    // Load an audio file
    const audioElement = new Audio('https://waypastbooks.com/assets/audio/welcome.mp3');

    // Connect the audio element to the AudioContext
    const source = audioContext.createMediaElementSource(audioElement);

    // Check if audio can be autoplayed
    audioContext.resume().then(() => {
      // Autoplay is allowed
      console.log('Autoplay is allowed');
     // playWelcome();
    }).catch((error) => {
      // Autoplay is not allowed
      console.error('Autoplay is not allowed', error);
    });

    // Start the audio playback (you can use this to test autoplay)
    audioElement.play();
    
  }
*/



  
const deviceType = () => {
    if (isMobile){
      return 'mobile';
    }else if (isTablet){
      return 'tablet';
    }else if (isDesktop){
      return 'desktop';
    }
  }

  useEffect(() => {
    const prev = prevPathRef.current;
    if (isOverlayPath(path) && prev && !isOverlayPath(prev)) {
      window.sessionStorage.setItem(OVERLAY_RETURN_PATH_KEY, prev);
    }
    prevPathRef.current = path;
  }, [path]);

  useEffect(() => {

  //  checkAutoplay();

  },[])


  useEffect(() => {

  
    setBkgdColor(sectionActive)
    setCharacter(sectionActive)
   // setTalk(sectionActive)
    setHomeMessage(messages[sectionActive])

    if (sectionActive === 0){
      setShowBug(false)
    }else{
      setShowBug(true)
    }    

  },[sectionActive])

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--section-color-dark',
      shadeColor(bkgdColor, -20)
    )
    document.documentElement.style.setProperty(
      '--section-color-darker',
      shadeColor(bkgdColor, -40)
    )
  }, [bkgdColor])

  useEffect(() => {
    const onHomePage = location === '/'

    // Cursor policy:
    // - Homepage: custom cursor (hide native cursor)
    // - All other routes/overlays: native cursor, custom cursor hidden
    document.body.style.cursor = onHomePage ? 'none' : 'auto'
    setCursorActive(onHomePage)

    return () => {
      document.body.style.cursor = 'auto'
    }
  }, [location, setCursorActive])

  useEffect(() => {
    if (!isBscFormPage) {
      window.sessionStorage.removeItem('bscFormOrigin')
    }
  }, [isBscFormPage])

  return (
    <>
  
     
   {/*  <AudioProvider />  */}
    {!isDrawdogsLikePage &&
       <>
        <CanvasScene />
        {(path.includes('/fun-and-games') || path.includes('/videos') || path.includes('/category')) &&
            <CategoryBar />
        }
        <Cursor />   
      </>
    }
       
            {isBscFormPage && keepBscOverlayUnderForm && <BscOverlay />}
            {routeResult}
            {isMobile &&
               <NavMobile />
            }
            
            {!isDrawdogsLikePage &&
              <div className="backPanel" style={{backgroundColor: bkgdColor}}></div>
            }
            <Nav />               
            {!isDrawdogsLikePage && <Overlay />}
            
          
            


         {/*   <ScrollWindow  />*/} 

       
    
    
       
    

      
 
  

      



     {/*  <TestControls checkSlides={checkSlides}/> */}
    </>
  );
}